import { render, staticRenderFns } from "./Shopcard.vue?vue&type=template&id=8ae3e1e2&scoped=true&"
import script from "./Shopcard.vue?vue&type=script&lang=js&"
export * from "./Shopcard.vue?vue&type=script&lang=js&"
import style0 from "./Shopcard.vue?vue&type=style&index=0&id=8ae3e1e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae3e1e2",
  null
  
)

export default component.exports